export default "__VITE_ASSET__C8UQdRdW__$_?url__"